export var ProductAttrFilterMode;
(function (ProductAttrFilterMode) {
    ProductAttrFilterMode["MODE_HIGHEST_SCORE_WINS"] = "highest_score_wins";
    ProductAttrFilterMode["MODE_MERGE_ALL_WINNERS"] = "merge_all_winners";
})(ProductAttrFilterMode || (ProductAttrFilterMode = {}));
